import DocumentTextIcon from '@heroicons/react/outline/DocumentTextIcon'
import clsx from 'clsx'

import { Post } from '@tribeplatform/gql-client/types'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'

import { getRandomColorById } from '../../../utils/colors'
import type { StaticField } from '../../Views/types'

interface Props {
  field: StaticField
  post: Post
  highlighted: boolean
  mediaUrl: string
  aspectRatio: StaticField['settings']['aspectRatio']
  preview: boolean
}
export const GalleryBanner = ({
  field,
  post,
  highlighted,
  mediaUrl,
  aspectRatio,
  preview,
}: Props) => {
  const { default: defaultUrl } = field
  const fieldMediaUrl = mediaUrl || (preview ? defaultUrl : '')

  switch (field.settings?.bannerStyle) {
    case 'banner':
      return (
        <div
          className={clsx(
            'w-full relative',
            aspectRatio || 'aspect-video',
            highlighted && 'border-2 border-focused',
          )}
        >
          <div
            className="w-full h-full flex justify-center items-center"
            style={{ backgroundColor: getRandomColorById(post?.id ?? '') }}
          >
            <DocumentTextIcon className="w-16 h-16 text-white" />
          </div>
          <div
            className="w-full h-full bg-cover bg-center absolute top-0 start-0"
            style={{ backgroundImage: `url(${fieldMediaUrl})` }}
          ></div>
        </div>
      )
    case 'square':
      return (
        <div className="pb-4 relative">
          <div
            className={clsx(
              'h-16 w-16 flex justify-center items-center rounded-md',
              highlighted && 'ring-2 ring-offset-surface ring-focused',
            )}
            style={{ backgroundColor: getRandomColorById(post?.id ?? '') }}
          >
            <DocumentTextIcon className="w-10 h-10 text-white" />
          </div>
          <div className="absolute top-0 start-0">
            <Avatar
              src={fieldMediaUrl}
              name=" "
              size="xl"
              rounded="md"
              style={{ backgroundColor: 'transparent' }}
            />
          </div>
        </div>
      )
    default:
      // Code should never reach the default case
      // eslint-disable-next-line no-case-declarations
      const exhaustiveCheck: never = field.settings?.bannerStyle
      return exhaustiveCheck
  }
}
